/**
 * 移动端策略
*/
import { i18n } from '@/i18n';
import { OPEN_IN_MOBILE_TITLE, WARNING_LOGO } from '../constants';
import { SceneConfigMapType, ComponentStrategyMapType, BusinessScene, PcBusinessComponentInfoMap, PcBusinessComponent, GetSceneParamsType } from '../type';

type PcComponentStrategyMapType = ComponentStrategyMapType<PcBusinessComponentInfoMap>;

/**
 * @description 链接异常时组件展示策略
 */
const errorLinkStrategy: PcComponentStrategyMapType = {
  [PcBusinessComponent.LOGO]: WARNING_LOGO,
  [PcBusinessComponent.LOGO_TITLE]: OPEN_IN_MOBILE_TITLE,
  [PcBusinessComponent.MAIN_TEXT]: i18n('若链接无法打开，请让收款人用微信扫一扫下方\n小程序码，完成收款操作'),
  [PcBusinessComponent.MINI_APP_QRCODE]: '//weremit-static.tenpay.com/upload-static/remit/OUVHuIbma7NaztBLfk2URv-group1410104969.png',
};

/**
 * @description 通用营销场景组件展示策略
 */
const commonMarketingsStrategy: PcComponentStrategyMapType = {
  [PcBusinessComponent.LOGO]: WARNING_LOGO,
  [PcBusinessComponent.LOGO_TITLE]: OPEN_IN_MOBILE_TITLE,
  [PcBusinessComponent.MAIN_TEXT]: i18n('若链接无法打开，请用微信扫一扫下方小程序码'),
  [PcBusinessComponent.MINI_APP_QRCODE]: '//weremit-static.tenpay.com/upload-static/remit/X7f500rz2TpjR5J1vbfwb0-group1410104971.png',
};

/**
 * @description 小鹅快收 - 收款人视角场景组件展示策略
 */
const receiverStrategy: PcComponentStrategyMapType = {
  [PcBusinessComponent.LOGO]: WARNING_LOGO,
  [PcBusinessComponent.LOGO_TITLE]: OPEN_IN_MOBILE_TITLE,
  [PcBusinessComponent.MAIN_TEXT]: i18n('若链接无法打开，请让收款人用微信扫一扫下方\n小程序码，完成收款操作'),
  [PcBusinessComponent.MINI_APP_QRCODE]: '//weremit-static.tenpay.com/upload-static/remit/hxpEou5xBvNIDPhrGEw3TG-group1410104970.png',
};

/**
 * @description 小鹅汇款人视角场景组件展示策略
 */
const quickReceiptRemitterStrategy: PcComponentStrategyMapType = {
  [PcBusinessComponent.LOGO]: '',
  [PcBusinessComponent.LOGO_TITLE]: i18n('打开{{0}}微信去通知收款人', true),
  [PcBusinessComponent.MAIN_TEXT]: i18n('请复制下方链接并发送给收款人，完成收款'),
  [PcBusinessComponent.COPY_LINK]: (sceneParams: GetSceneParamsType) => sceneParams.copyLink,
  [PcBusinessComponent.SUB_TEXT]: i18n('或打开微信扫描下方小程序码通知收款人'),
};

/**
 * @description 组件展示策略Map
*/
export const sceneConfig: SceneConfigMapType<PcBusinessComponentInfoMap> = {

  [BusinessScene.ERROR_LINK]: errorLinkStrategy,

  [BusinessScene.COMMON_MARKETINGS]: commonMarketingsStrategy,

  [BusinessScene.QUICK_RECEIPT_RECEIVER]: receiverStrategy,

  [BusinessScene.QUICK_RECEIPT_REMITTER]: quickReceiptRemitterStrategy,
};
